







































































































































































































































































































































































































































import { Component, Prop, Vue, Inject } from 'vue-property-decorator';
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import { CrudService } from '@/data/services/crud.service';
import { Headquarter } from '@/data/models/headquarter.model';
import { Country } from '@/data/models/country.model';
import { Comune } from '@/data/models/comune.model';
import { Provincia } from '@/data/models/provincia.model';
import { Search } from '@/data/models/search.model';
import { Page } from '@/data/models/page.model';
import { ClassType } from 'class-transformer/ClassTransformer';
import { Attach } from '@/data/models/attach.model';
import { cloneDeep } from 'lodash';
import { AttachSize } from '@/data/models/attach.model';
import { AttachService } from '@/data/services/attach.service';

@Component({
	components: {
		ValidationObserver,
		ValidationProvider
	}
})
export default class HeadquarterGeneralData extends Vue {
	@Prop() headquarter!: Headquarter;
	@Prop() editable!: boolean;

	@Inject('CrudService') headquarterCrudService!: CrudService<Headquarter>;

	@Inject('CrudService') nazioneCrudService!: CrudService<Country>;
	@Inject('CrudService') provinciaCrudService!: CrudService<Provincia>;
	@Inject('CrudService') comuneCrudService!: CrudService<Comune>;
	@Inject('CrudService') attachCrudService!: CrudService<Attach>;
	@Inject('AttachService') attachService!: AttachService;

	newHeadquarter!: Headquarter;

	provinciaClass: ClassType<Provincia> = Provincia;
	comuneClass: ClassType<Comune> = Comune;
	comuneSearch: Search = new Search('comuni');
	provincia: Provincia | null = null;
	comune: Comune | null = null;

	file: any = null;

	constructor() {
		super();
		this.newHeadquarter = new Headquarter();
	}

	loadProvince() {
		const search = new Search('province');
		search.addSimpleFilter('descrizione', this.newHeadquarter.province as string);
		this.provinciaCrudService
			.searchEntities(Provincia, 'province', search, new Page(10))
			.then(result => this.provincia = result[0]);
	}

	loadComuni() {
		if (!this.newHeadquarter.province) {
			return;
		}
		const search = new Search('comuni');
		search.addSimpleFilter('provincia', this.newHeadquarter.province);
		search.addSimpleFilter('descrizione', this.newHeadquarter.city as string);
		this.comuneCrudService
			.searchEntities(Comune, 'comuni', search, new Page(100))
			.then(result => this.comune = result[0]);
	}

	loadHeadquarterImage() {
		this.attachService.downloadImage(this.newHeadquarter.logo as string, AttachSize.MD)
			.then((response: any) => {
				if (response.data && response.status === 200) {
					this.$set(this.newHeadquarter, 'previewurl', URL.createObjectURL(response.data));
				}
			}).catch(({ data }) => {
				if (data) {
					this.$buefy.notification.open({
						message: data.msg || data.internal,
						type: 'is-danger',
					});
				}
			});
	}

	onProvinciaChange() {
		if (this.provincia) {
			this.newHeadquarter.province = this.provincia.descrizione;
			this.newHeadquarter.city = undefined;
			this.comuneSearch.addSimpleFilter('provincia', this.provincia.descrizione as string);
		}
	}

	onComuneChange() {
		if (this.comune) this.newHeadquarter.city = this.comune.descrizione;
	}

	submit() {
		this.headquarterCrudService
			.createEntity(Headquarter, 'headquarter', this.newHeadquarter)
			.then((headquarter: Headquarter) => {
				this.newHeadquarter = headquarter;
				if (this.file) {
					this.saveHeadquarterLogo();
				} else {
					this.loadHeadquarterImage();
				}
				this.$buefy.notification.open({
					message: this.$t('success-save') as string,
					type: 'is-success',
				});
				this.$emit('update:headquarter', headquarter);
			})
			.catch(({ data }) => {
				this.$buefy.notification.open({
					message: data.msg || data.internal,
					type: 'is-danger',
				});
			});
	}

	saveHeadquarterLogo() {
		const formData = new FormData();
		formData.append('file', this.file);
		this.attachCrudService.uploadEntity(Attach, 'headquarter', this.newHeadquarter.id, formData)
			.then((attach: Attach) => {
				const headquarter = cloneDeep(this.newHeadquarter);
				headquarter.logo = attach.opaqueid;
				this.headquarterCrudService.saveEntity(Headquarter, 'headquarter', headquarter).then(result => {
					this.newHeadquarter = result;
					this.file = null;
					this.loadHeadquarterImage();
					this.$emit('update:headquarter', headquarter);
				});
			})
			.catch((error) => {
				this.$buefy.notification.open({
					message: error.msg,
					type: 'is-danger',
				});
			});
	}

	beforeMount() {
		this.newHeadquarter = cloneDeep(this.headquarter);
		this.loadHeadquarterImage();
		this.loadProvince();
		this.loadComuni();
	}

}
